"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _getEarlyRequesterResultPromise = _interopRequireDefault(require("settings-ui-sdk/getEarlyRequesterResultPromise"));

var INBOUNDDB_QUOTE_WORKFLOWS_URL = 'inbounddbquotes/v1/workflows/approval';

var QuoteApprovalAPI =
/*#__PURE__*/
function () {
  function QuoteApprovalAPI() {
    (0, _classCallCheck2.default)(this, QuoteApprovalAPI);
  }

  (0, _createClass2.default)(QuoteApprovalAPI, null, [{
    key: "fetchWorkflowsExistence",
    value: function fetchWorkflowsExistence() {
      return (0, _getEarlyRequesterResultPromise.default)('quote-approval-workflows') || _apiClient.default.get(INBOUNDDB_QUOTE_WORKFLOWS_URL + "/existence");
    }
  }, {
    key: "createWorkflows",
    value: function createWorkflows(approverUserIds) {
      return _apiClient.default.post(INBOUNDDB_QUOTE_WORKFLOWS_URL, {
        data: {
          approverUserIds: approverUserIds
        }
      });
    }
  }]);
  return QuoteApprovalAPI;
}();

exports.default = QuoteApprovalAPI;
module.exports = exports.default;